const articleParentTitleLink = (
  articleType?: string,
  articleTypeSlug?: string,
  articleTaxonomy?: string,
  articleTypeTitle?: string
) => {
  let lozengeTitle = 'News'
  // If articleType is artist or genre then we need a special link.

  let slug = '/articles'
  switch (articleType) {
    case 'artist':
      slug = `/artist-${articleTypeSlug}/articles`
      break
    case 'genre':
      slug = `/genre-${articleTypeSlug}/articles`
      break
    default:
      slug = `/articles/${articleTypeSlug}`
  }

  if (articleTypeTitle) {
    lozengeTitle = articleTypeTitle
  } else {
    // Deliberately allows an empty/undefined result: callers treat a falsy
    // title as "render no lozenge", which is correct for articles that have
    // neither a parent nor a primary category.
    lozengeTitle = articleTypeSlug ? articleTypeSlug : (articleType as string)
  }

  return {
    title: lozengeTitle,
    link: slug,
  }
}

export default articleParentTitleLink
